export default __webpack_public_path__ + "static/media/claro.f9867823.svg";